export default __webpack_public_path__ + "assets/langSwitcher4.png";